import { createAsyncActionConstants } from 'utilities/util';

export const TYPES = {
    FETCH_VESSEL_SCHEDULE_LIST: createAsyncActionConstants('FETCH_VESSEL_SCHEDULE_LIST'),
    CREATE_VESSEL_SCHEDULE: createAsyncActionConstants('CREATE_VESSEL_SCHEDULE'),
    UPDATE_VESSEL_SCHEDULE: createAsyncActionConstants('UPDATE_VESSEL_SCHEDULE'),
};
